module.exports = "./img/82f6fb730c81d663c22a357aa88f4cfb.png";